import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import debounce from 'lodash/debounce';
import { nanoid } from 'nanoid';
import { ref } from 'vue';

import { logger } from '@exchange/libs/utils/simple-logger/src';

import type { Toast } from './toast-manager';
import ToastWrapper from './ToastWrapper.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastsContainer',
  props: {
  maxToastNumber: {
    type: Number,
    default: 6,
  },
},
  setup(__props, { expose: __expose }) {

const ordersMap: Map<string, (toast: Toast) => void> = new Map();

const props = __props;
const toasts = ref<Array<Toast & { internalId: string }>>([]);

const pushToast = (toast) => {
  toasts.value.push({
    ...toast,
    internalId: nanoid(),
  });
};

const handleOrderToasts = (toast: Toast) => {
  const orderId = toast.order as string;

  if (ordersMap.has(orderId)) {
    // if order is on map - get debounced function
    const pushOrderToast = ordersMap.get(orderId);

    if (pushOrderToast) {
      pushOrderToast(toast);
    }
  } else {
    // if order is NOT on map - set debounced function
    const pushOrderToast = debounce(pushToast, 400);

    ordersMap.set(orderId, pushOrderToast);
    pushOrderToast(toast);
  }
};

const handleOrderMapCleaning = (order?: string) => {
  if (order && ordersMap.has(order)) {
    ordersMap.delete(order);
  }
};

const removeToast = ($event) => {
  toasts.value = toasts.value.filter((t) => t.internalId !== $event.id);

  handleOrderMapCleaning($event.order);
};

/**
 * toast is an object with the following props
 * `content` - component for the toast content
 * `props` - properties of the content component
 *  `duration` - time before remove
 *  `order` - is order-related toast, this is order id
 */
const addToast = (toast: Toast) => {
  if (!toast.content) {
    logger.error('Nothing to show on toast');
  }

  requestAnimationFrame(() => {
    if (toasts.value.length >= props.maxToastNumber) {
      toasts.value.shift();
    }

    if ('order' in toast) {
      handleOrderToasts(toast);
    } else {
      pushToast(toast);
    }
  });
};

__expose({ addToast });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_TransitionGroup, {
    class: "toasts-container",
    name: "toasts",
    tag: "div"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toasts.value, (toast) => {
        return (_openBlock(), _createElementBlock("div", {
          key: toast.internalId,
          class: "toasts-container__wrapper"
        }, [
          _createVNode(ToastWrapper, {
            toast: toast,
            onRemove: _cache[0] || (_cache[0] = ($event: any) => (removeToast($event)))
          }, null, 8, ["toast"])
        ]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})